import { Suspense } from 'react';
import { useNovel } from '@/context/novel-context';
import { useEntity } from '@/hooks/use-entity';
import type { EntitySummary, Event } from '@/lib/types';
import { EventDetailsDialog } from '@/components/event-details-dialog';

interface EventPopupLoaderProps {
  eventId: string;
  open: boolean;
  onClose: () => void;
  locations: EntitySummary[];
  characters: EntitySummary[];
  organizations: EntitySummary[];
}

export function EventPopupLoader({
  eventId,
  open,
  onClose,
  locations,
  characters,
  organizations,
}: EventPopupLoaderProps) {
  const { novel } = useNovel();
  const { data: event, isLoading } = useEntity<Event>('events', eventId);

  if (isLoading) return null;

  return (
    <Suspense fallback={null}>
      <EventDetailsDialog
        novelId={novel?.id || null}
        event={event}
        open={open}
        onOpenChange={(isOpen) => !isOpen && onClose()}
        locations={locations}
        characters={characters}
        organizations={organizations}
      />
    </Suspense>
  );
}
export default EventPopupLoader;
